import { Component, OnInit } from '@angular/core';
import { AssetManagementReportService } from '../../reports/reports.service';
import { AssetManagement, Header } from '@aptsi-types';
import { AssetManagementDashboardService } from './dashboard.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-asset-management-dashboard',
  templateUrl: './asset-management-dashboard.component.html',
  styleUrls: ['./asset-management-dashboard.component.scss']
})
export class AssetManagementDashboardComponent implements OnInit {
  constructor(
    private assetManagementReportService: AssetManagementReportService,
    private assetManagementDashboardService: AssetManagementDashboardService,
    private route: ActivatedRoute
  ) {}

  data: AssetManagement[] = [];
  chartdata: AssetManagement[] = [];
  dashBoardData: AssetManagement | null = null;
  selectedFilter: 'last_7_days' | 'last_month' | 'all_time' = 'all_time';

  headers: Header[] = [
    { name: 'Asset Source Name', property: 'assetSourceName', showInDropdown: true },
    { name: 'Asset Type', property: 'assetType', showInDropdown: true },
    { name: 'Asset Source', property: 'assetSource', showInDropdown: true },
    { name: 'Asset Count', property: 'capturedAssetCount', showInDropdown: true }
  ];

  chartData: any = {};

  ngOnInit(): void {
    const resolved = this.route.snapshot.data['dashboard'];

    this.dashBoardData = resolved?.dashBoardData ?? null;
    this.data = resolved?.data?.assetSourceSummaryReport ?? [];
    this.chartdata = resolved?.chartdata?.lineChartDTOs ?? [];

    this.chartData = {
      labels: this.chartdata.map(item => item.lastCheckedAt),
      datasets: [
        {
          label: 'Percentage of Up Assets',
          data: this.chartdata.map(item => item.upAssets),
          borderColor: '#2850ad',
          backgroundColor: 'rgba(40, 80, 173, 0.12)',
          pointBackgroundColor: '#0e2e80',
          pointBorderColor: '#ffffff',
          pointBorderWidth: 2,
          pointRadius: 3,
          pointHoverRadius: 5,
          borderWidth: 2.5,
          tension: 0.32,
          fill: true
        }
      ]
    };
  }

  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      intersect: false,
      mode: 'index' as const
    },
    plugins: {
      legend: {
        position: 'top' as const,
        align: 'start' as const,
        labels: {
          color: '#4b5870',
          usePointStyle: true,
          pointStyle: 'circle',
          boxWidth: 8,
          boxHeight: 8,
          padding: 18
        }
      },
      tooltip: {
        enabled: true,
        backgroundColor: '#07112e',
        titleColor: '#ffffff',
        bodyColor: '#ffffff',
        padding: 10,
        cornerRadius: 8,
        displayColors: true
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        border: {
          display: false
        },
        ticks: {
          color: '#6f7b91',
          maxRotation: 0,
          autoSkip: true
        },
        title: {
          display: true,
          text: 'Days',
          color: '#4b5870',
          font: {
            weight: '600' as const
          }
        }
      },
      y: {
        min: 0,
        max: 100,
        grid: {
          color: '#e9edf3'
        },
        border: {
          display: false
        },
        ticks: {
          color: '#6f7b91',
          callback: (value: string | number) => `${value}%`
        },
        title: {
          display: true,
          text: 'Percentage of Up Assets',
          color: '#4b5870',
          font: {
            weight: '600' as const
          }
        }
      }
    }
  };
}
